import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AccessLevels() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 sm:pt-40 lg:pt-56 pb-12 sm:pb-16 lg:pb-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-6 sm:mb-8">
            Access Levels
          </h1>
          <p className="text-xl sm:text-2xl lg:text-3xl text-gray-700 mb-6 sm:mb-8 font-normal leading-relaxed">
            A progression of responsibility — not usage.
          </p>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-4 sm:mb-6 font-normal leading-relaxed">
            Halvera access levels define how much of your life's coordination, protection, and disruption Halvera assumes responsibility for.
          </p>
          <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8 text-sm sm:text-base lg:text-lg text-gray-600">
            <p>Not how often you travel.</p>
            <p>Not how many requests you make.</p>
            <p>Not what you "use."</p>
          </div>
          <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900">
            Responsibility.
          </p>
        </div>
      </section>

      {/* Halvera Core */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            Halvera Core
          </h2>
          <p className="text-xl sm:text-2xl lg:text-3xl text-gray-700 mb-6 sm:mb-8 font-normal">
            Life runs properly.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 font-normal leading-relaxed">
            Core is designed for people who want their plans to work — without friction, stress, or constant follow-up.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 font-normal leading-relaxed">
            Halvera handles coordination and resolution when things break, so problems don't cascade into your day.
          </p>
          <div className="bg-white p-6 sm:p-8 rounded-lg border-2 border-gray-200 mb-8 sm:mb-10">
            <p className="text-base sm:text-lg text-gray-900 font-semibold mb-2 sm:mb-3">
              Core removes inefficiency.
            </p>
            <p className="text-sm sm:text-base text-gray-600 font-normal">
              It does not assume full responsibility.
            </p>
          </div>
          <div className="mb-8 sm:mb-10">
            <p className="text-sm font-semibold text-gray-900 mb-3 sm:mb-4 uppercase tracking-wide">
              Best for:
            </p>
            <p className="text-base sm:text-lg text-gray-700 font-normal leading-relaxed">
              Individuals who travel or move regularly and want reliability without complexity.
            </p>
          </div>
          <Link 
            to="/apply" 
            className="inline-flex items-center px-7 sm:px-8 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Apply for Core Access
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </section>

      {/* Halvera Reserve */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            Halvera Reserve
          </h2>
          <p className="text-xl sm:text-2xl lg:text-3xl text-gray-700 mb-6 sm:mb-8 font-normal">
            You're prioritized when things break.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 font-normal leading-relaxed">
            Reserve is for people whose time is expensive and tolerance for disruption is low.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 font-normal leading-relaxed">
            When plans change, Reserve members move to the front of the line — across coordination, access, and protection.
          </p>
          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg border-2 border-gray-200 mb-8 sm:mb-10">
            <p className="text-base sm:text-lg text-gray-900 font-semibold mb-2 sm:mb-3">
              You're no longer just supported.
            </p>
            <p className="text-sm sm:text-base text-gray-600 font-normal">
              You're prioritized.
            </p>
          </div>
          <div className="mb-8 sm:mb-10">
            <p className="text-sm font-semibold text-gray-900 mb-3 sm:mb-4 uppercase tracking-wide">
              Best for:
            </p>
            <p className="text-base sm:text-lg text-gray-700 font-normal leading-relaxed">
              Leaders, operators, and professionals whose absence or delay has real consequences.
            </p>
          </div>
          <Link 
            to="/apply" 
            className="inline-flex items-center px-7 sm:px-8 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Apply for Reserve Access
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </section>

      {/* Halvera Ascend */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            Halvera Ascend
          </h2>
          <p className="text-xl sm:text-2xl lg:text-3xl text-gray-700 mb-6 sm:mb-8 font-normal">
            You don't manage logistics at all.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 font-semibold">
            Ascend is full responsibility.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 font-normal leading-relaxed">
            Halvera assumes end-to-end ownership across coordination, access, and continuity — even as situations change.
          </p>
          <div className="bg-white p-6 sm:p-8 rounded-lg border-2 border-gray-200 mb-6 sm:mb-8">
            <p className="text-base sm:text-lg text-gray-900 font-semibold mb-2 sm:mb-3">
              Ascend isn't about more service.
            </p>
            <p className="text-sm sm:text-base text-gray-600 font-normal">
              It's about less thinking.
            </p>
          </div>
          <p className="text-base sm:text-lg text-gray-700 mb-8 sm:mb-10 font-normal">
            Access is limited.
          </p>
          <div className="mb-8 sm:mb-10">
            <p className="text-sm font-semibold text-gray-900 mb-3 sm:mb-4 uppercase tracking-wide">
              Best for:
            </p>
            <p className="text-base sm:text-lg text-gray-700 font-normal leading-relaxed">
              Executives, founders, partners, and individuals who expect their life to keep moving regardless of complications.
            </p>
          </div>
          <Link 
            to="/apply" 
            className="inline-flex items-center px-7 sm:px-8 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Request Ascend Consideration
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </section>

      {/* How Companies Use Access Levels */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">
            How Companies Use Access Levels
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 mb-4 sm:mb-6 text-center font-normal leading-relaxed">
            Organizations don't buy features.
          </p>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 mb-8 sm:mb-10 text-center font-semibold">
            They assign responsibility.
          </p>
          <div className="bg-gray-50 p-6 sm:p-8 lg:p-10 rounded-lg mb-8 sm:mb-10">
            <p className="text-sm font-semibold text-gray-900 mb-4 sm:mb-6 uppercase tracking-wide">
              Typical structure:
            </p>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <p className="text-base sm:text-lg font-semibold text-gray-900">Core</p>
                  <p className="text-sm sm:text-base text-gray-600 font-normal">general employees</p>
                </div>
              </li>
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <p className="text-base sm:text-lg font-semibold text-gray-900">Reserve</p>
                  <p className="text-sm sm:text-base text-gray-600 font-normal">leaders and key contributors</p>
                </div>
              </li>
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <p className="text-base sm:text-lg font-semibold text-gray-900">Ascend</p>
                  <p className="text-sm sm:text-base text-gray-600 font-normal">executives, partners, critical roles</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="text-center space-y-2 mb-8 sm:mb-10 text-base sm:text-lg text-gray-700 font-normal">
            <p>One system.</p>
            <p>Clear standards.</p>
            <p>No complexity.</p>
          </div>
          <div className="text-center">
            <Link 
              to="/apply" 
              className="inline-flex items-center px-7 sm:px-8 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
            >
              Talk to Halvera — Companies
              <i className="ri-arrow-right-line ml-2 text-lg"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* A Note on Access */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6 sm:mb-8">
            A Note on Access
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-4 sm:mb-6 font-normal leading-relaxed">
            Halvera access is intentionally limited.
          </p>
          <p className="text-base sm:text-lg text-gray-400 mb-2 sm:mb-3 font-normal">
            This isn't a plan you select at checkout.
          </p>
          <p className="text-base sm:text-lg text-gray-400 mb-8 sm:mb-10 font-normal">
            It's access that's granted based on fit.
          </p>
          <p className="text-sm sm:text-base text-gray-400 mb-8 sm:mb-10 font-normal">
            If you're unsure which level applies, start with the application.
          </p>
          <Link 
            to="/apply" 
            className="inline-flex items-center px-8 sm:px-10 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Apply for Access
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
